export default "__VITE_ASSET__zJyG0p____"